export const albumSliceName = "album"
